import React from 'react';

const TreatmentTimeline = () => {
  const timelineEvents = [
    { label: "Diagnosis", date: "Mar '22", color: "red" },
    { label: "Chemo", date: "Apr-Jul'22", color: "blue" },
    { label: "Surgery", date: "Sep '22", color: "orange" },
    { label: "Chemo", date: "Oct-Jan'23", color: "blue" },
    { label: "Current", date: "", color: "green" },
  ];
  
  return (
    <div className="bg-white p-4 rounded-lg shadow mb-4">
      <div className="relative py-6">
        {/* Timeline bar */}
        <div className="h-1 bg-gray-200 absolute w-full top-1/2"></div>
        
        {/* Timeline events */}
        <div className="flex justify-between relative">
          {timelineEvents.map((event, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className={`w-6 h-6 rounded-full bg-${event.color}-500 z-10 border-2 border-white`}></div>
              <div className="text-sm font-medium mt-2">{event.label}</div>
              <div className="text-xs text-gray-500">{event.date}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="text-center text-blue-500 hover:underline cursor-pointer">
        [Expand Full Timeline]
      </div>
    </div>
  );
};

export default TreatmentTimeline;